var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400 700C565.685 700 700 565.685 700 400C700 234.315 565.685 100 400 100C234.315 100 100 234.315 100 400C100 565.685 234.315 700 400 700Z",
    stroke: "#8E8E93",
    strokeWidth: 66.6667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 533.333V400",
    stroke: "#8E8E93",
    strokeWidth: 66.6667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 275V279.167",
    stroke: "#8E8E93",
    strokeWidth: 66.6667,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGray);
export default __webpack_public_path__ + "static/media/infoGray.21455c1302ba282043beb16d0ca1b5f2.svg";
export { ForwardRef as ReactComponent };